export const RESET = 'EXCMAGREEMENT_UPDATE_RESET'
export const SET_ERROR = 'EXCMAGREEMENT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMAGREEMENT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMAGREEMENT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMAGREEMENT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMAGREEMENT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMAGREEMENT_UPDATE_UPDATE_RETRIEVED'
